/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component, { type ComponentAttrs } from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import { startReviewsTour } from '../extend/reviewsTour';
import app from 'flarum/forum/app';
import type Mithril from 'mithril';

export interface ReviewFeatureAlertBodyAttrs extends ComponentAttrs {
	/** Injected by `AlertManager`; dismisses the alert this body is rendered inside. */
	dismiss: () => void;
}

export default class ReviewFeatureAlertBody extends Component<ReviewFeatureAlertBodyAttrs> {
	oninit(vnode: Mithril.Vnode<ReviewFeatureAlertBodyAttrs, this>) {
		super.oninit(vnode);
	}

	view(): Mithril.Children {
		return (
			<div className="ReviewFeatureAlertBody">
				<h4 className="ReviewFeatureAlertBody-title">{app.translator.trans('glowingblue-orell-rezensionen.forum.review_feature_alert.title')}</h4>
				<p className="ReviewFeatureAlertBody-text">{app.translator.trans('glowingblue-orell-rezensionen.forum.review_feature_alert.text')}</p>
				<div className="ReviewFeatureAlertBody-action">
					<Button className="Button Button--link" onclick={this.handleAction.bind(this)}>
						{app.translator.trans('glowingblue-orell-rezensionen.forum.review_feature_alert.button_label')}
					</Button>
				</div>
			</div>
		);
	}

	handleAction() {
		const { dismiss } = this.attrs;

		startReviewsTour();

		dismiss();
	}
}
